import { useComposerState } from '#pplx/frontend/composer-sdk/internal/input-state/useComposerState.js';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import React, { useEffect } from 'react';
/**
 * Mounts inside `LexicalComposer` and keeps `ComposerProvider`'s `hasDraft`
 * boolean in sync with non-whitespace editor text and plugin-contributed
 * content. `setHasDraft` short-circuits no-op transitions, so per-keystroke
 * dispatches do not re-render provider consumers.
 */
export const DraftTrackerPlugin = React.memo(function DraftTrackerPlugin({ hasPluginContent }) {
    const [editor] = useLexicalComposerContext();
    const { setHasDraft } = useComposerState();
    useEffect(() => {
        if (hasPluginContent) {
            setHasDraft(true);
            return;
        }
        const updateHasDraft = (textContent) => {
            setHasDraft(textContent.trim().length > 0);
        };
        updateHasDraft(editor.getEditorState().read(() => $getRoot().getTextContent()));
        return editor.registerTextContentListener(updateHasDraft);
    }, [editor, hasPluginContent, setHasDraft]);
    return null;
});
//# sourceMappingURL=DraftTrackerPlugin.js.map